import { State } from "infrontjs";
import template from "./NotFoundTemplate.html";

/**
 * NotFoundState — a route no state answers (an old or mistyped link such as
 * `#/discover`). Registered as the router's not-found state in App.init.
 *
 * Replaces InfrontJS' default, which writes its splash over the whole
 * container: that took the shell with it, so even `#/` stayed blank until a
 * reload. This one renders inside the shell like any screen — into the
 * page-content slot when signed in (tab bar hidden), into #main-wrapper when
 * not — so the next navigation simply works.
 *
 * Open to everyone (no auth guard): "Zur Startseite" goes to `/`, which sends
 * a guest without a session on to the login.
 */
export class NotFoundState extends State
{
    static ROUTE = null;
    static ID = "not-found";

    showsBottomNav() { return false; }

    getActiveTab() { return null; }

    async enter()
    {
        const host = this.app.view.pageContent || this.app.container.querySelector( "#main-wrapper" );
        if ( !host )
        {
            return;
        }
        this.app.view.render( host, template, {} );

        const home = host.querySelector( '[data-id="home"]' );
        if ( home )
        {
            this.addEventListener( home, "click", () => this.app.router.redirect( "/" ) );
        }
    }

    async exit()
    {
        if ( this.app.view.pageContent )
        {
            this.app.view.pageContent.innerHTML = "";
        }
    }
}
